import React from 'react';
import { Col, Row, Select } from 'antd';
import { I18n } from '@aws-amplify/core';

import { getVersionLabel } from './utils';
import { FieldLabel } from './styles';

import type { BeraVersion } from '@/types/Bera';

const SINGLE_VERSION = 1;
const LABEL_GUTTER = 8;
const SELECT_WIDTH = '15rem';

interface VersionPickerProps {
	value: string;
	versions: BeraVersion[];
	onChange: (versionId: string) => void;
}

export function VersionPicker({ value, versions, onChange }: Readonly<VersionPickerProps>): JSX.Element {
	const isDisabled = versions.length <= SINGLE_VERSION;

	const options = versions.map((version, index) => ({
		value: version.id,
		label: getVersionLabel(version, index)
	}));

	return (
		<Row justify="end">
			<Col>
				<Row gutter={[0, LABEL_GUTTER]}>
					<Col span={24}>
						<FieldLabel>{I18n.get('Version')}</FieldLabel>
					</Col>
					<Col span={24}>
						<Select<string>
							size="large"
							value={value}
							options={options}
							disabled={isDisabled}
							onChange={onChange}
							style={{ width: SELECT_WIDTH }}
							aria-label={I18n.get('Version')}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
